// QRScanner.jsx
import React, { useEffect, useRef, useState } from 'react';
import QrScanner from 'qr-scanner';
import { Box, colors, Typography, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Button, useMediaQuery } from '@mui/material';
import { validate, version } from 'uuid'
import BASE_URL from '../../NetworkConfig/ApiConfig';
import { AddOutlined, ChatRounded, Comment, CommentBankOutlined, CommentRounded, DeleteOutlineRounded, ExplicitRounded, FavoriteRounded, FlagOutlined, LinkRounded, RemoveRedEye, SendRounded } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';


const UserContent = () => {
    const videoRef = useRef(null);
    const [result, setResult] = useState('');
    const qrScannerRef = useRef(null);
    const [scanning, setScanning] = useState(false)
    const [scannedCoupon, setScannedCoupon] = useState({})
    const [loadingDetails, setLoadingDetails] = useState(false)
    const [option, setOption] = useState('post');
    const [contentType, setContentType] = useState('all');
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedDateMembers, setSelectedDateMembers] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(20)
    const [hasEnded, setHasEnded] = useState(false)
    const [postData, setPostData] = useState([])
    const navigate = useNavigate()


    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:700px)')

    const handleChange = (event) => {
        setOption(event.target.value);
    };


    const handleChangeType = (event) => {
        setContentType(event.target.value);
    };

    useEffect(() => {
        getPosts(1, option, selectedDate || "", contentType == "flagged")
    }, [selectedDate, contentType, option])



    const getPosts = async (page, type, date, isFlagged) => {
        setLoadingDetails(true);
        if (page == 1) {
            setPostData([])
            setHasEnded(false)
        }
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/metrics/getall/${type}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
            body: JSON.stringify({
                date: date,
                isFlagged: isFlagged,
                page: page,
                limit: limit
            })
        });
        const data = await response.json();

        console.log(data)

        if (data.success === true) {
            setPostData(prev => page == 1 ? data.response : [...prev, ...data.response])
            setCurrentPage(page)
            if (data.response.length < limit) {
                setHasEnded(true)
            }

        } else {
            alert(data.response)
        }

        setLoadingDetails(false)
    };

    const deletePost = async (postId) => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/metrics/delete-flagged-post`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
            body: JSON.stringify({
                clearence_id: postId
            })
        });
        const data = await response.json();
        if (data.success === true) {
            alert(data.response)
        } else {
            alert(data.response)
        }
        setLoadingDetails(false)
    };

    const clearFlag = async (postId) => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/metrics/clear-flag`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
            body: JSON.stringify({
                clearence_id: postId
            })
        });
        const data = await response.json();
        if (data.success === true) {
            alert(data.response)
        } else {
            alert(data.response)
        }
        setLoadingDetails(false)
    };

    const handleDateChange = (e) => {
        const { value } = e.target;
        //console.log("------", value)
        setSelectedDate(value);
        //const date = Convet_Date_To_Supported_Date(value)
        //FetchActivityDataByDate(value)
    };
    const HandleDateClick = () => {
    };
    const HandleResetClick = () => {
        setSelectedDateMembers([])
        setSelectedDate(null);
    };

    const getFormattedTime = (dateTime) => {
        const formatted = new Date(dateTime).toLocaleString('en-IN', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });

        return formatted
    }

    const handleDelete = (id) => {
        const confirm = window.confirm("Are you sure you want to delete this post?");
        if (confirm) {
            deletePost(id)
        }
    };


    const handleClearFlag = (id) => {
        const confirm = window.confirm("Do you want to remove the explicit flag on this post?");
        if (confirm) {
            clearFlag(id)
        }
    };


    return (
        <Box style={{ display: 'flex', flexDirection: 'column' }}>

            <Box sx={{ height: "1px", background: "#aaaaaa10", marginTop: "1px", alignSelf: 'stretch' }} />


            <Box sx={{
                display: 'flex', flexDirection: "row", alignItems: "center", flexWrap: "wrap", gap: "10px"
            }}>
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }} >
                    <Typography style={{
                        fontFamily: 'poppins-reg', fontSize: "20px", color: "#ffffff", marginInline: "20px", marginTop: "20px",
                    }}>Content Management</Typography>
                    <Typography style={{
                        fontFamily: 'poppins-reg', fontSize: "13px", color: "#ffffff80", marginInline: "20px",
                    }}>Moderate posts, crisps and gossips of the all community users.</Typography>
                </Box>
                <Box
                    onClick={() => {
                        navigate("/admin/new-post")
                    }}
                    sx={{
                        flexDirection: 'row', alignItems: 'center', display: 'flex', background: "#ffffff10",
                        borderRadius: "8px", paddingInline: "12px", paddingBlock: "8px", gap: "5px", marginRight: "20px",
                        border: "0px solid #ffffff40", cursor: 'pointer', marginBottom: isMobileScreen ? "15px" : "0px"
                    }}>
                    <AddOutlined />
                    <Typography color={"#ffffff"}
                        fontFamily={"poppins-reg"}
                        fontSize={"14px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >Create a post</Typography>

                </Box>
            </Box>



            <Box sx={{
                paddingInline: "20px", paddingBlock: "20px",
                alignSelf: 'stretch', flexWrap: 'wrap',
                flexDirection: 'row', display: 'flex', gap: "10px",
            }}>

                <FormControl sx={{}}>
                    <Select
                        value={option}
                        onChange={handleChange}
                        displayEmpty
                        input={<OutlinedInput />}
                        inputProps={{
                            'aria-label': 'Without label',
                            sx: {
                                height: 38,
                                paddingY: '6px',
                                color: 'white',
                            },
                        }}
                        sx={{
                            fontSize: 13,
                            fontFamily: "poppins-reg",
                            backgroundColor: '#1e1e1e',
                            borderRadius: "100px",
                            '.MuiOutlinedInput-notchedOutline': {
                                borderColor: 'rgba(255, 255, 255, 0.1)',
                                borderRadius: "100px"
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#90caf9',
                                borderRadius: "100px"
                            },
                            '.MuiSvgIcon-root': {
                                color: '#fff',
                            },
                        }}
                    >
                        <MenuItem value="" disabled>
                            Select Option
                        </MenuItem>
                        <MenuItem value="post" style={{ fontFamily: "poppins-reg" }}>Posts</MenuItem>
                        <MenuItem value="crisp" style={{ fontFamily: "poppins-reg" }}>Crisps</MenuItem>
                        <MenuItem value="gossip" style={{ fontFamily: "poppins-reg" }}>Gossips</MenuItem>
                    </Select>
                </FormControl>


                <FormControl sx={{}}>
                    <Select
                        value={contentType}
                        onChange={handleChangeType}
                        displayEmpty
                        input={<OutlinedInput />}
                        inputProps={{
                            'aria-label': 'Without label',
                            sx: {
                                height: 38,
                                paddingY: '6px',
                                color: 'white',
                            },
                        }}
                        sx={{
                            fontSize: 13,
                            fontFamily: "poppins-reg",
                            backgroundColor: '#1e1e1e',
                            borderRadius: "100px",
                            '.MuiOutlinedInput-notchedOutline': {
                                borderColor: 'rgba(255, 255, 255, 0.1)',
                                borderRadius: "100px"
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#90caf9',
                                borderRadius: "100px"
                            },
                            '.MuiSvgIcon-root': {
                                color: '#fff',
                            },
                        }}
                    >
                        <MenuItem value="" disabled>
                            Select Option
                        </MenuItem>
                        <MenuItem value="all" style={{ fontFamily: "poppins-reg" }}>All Type</MenuItem>
                        <MenuItem value="flagged" style={{ fontFamily: "poppins-reg" }}>Flagged</MenuItem>
                    </Select>
                </FormControl>


                <Box
                    display={"flex"}
                    justifyContent="flex-start"
                    alignItems={"center"}
                >
                    <input
                        type="date"
                        name=""
                        id=""
                        value={selectedDate}
                        onChange={handleDateChange}
                        style={{
                            paddingLeft: "10px", paddingTop: '3px',
                            paddingRight: "10px", paddingBottom: '3px',
                            fontFamily: 'poppins-reg',
                            backgroundColor: "#ffffff00",
                            border: '1px solid #ffffff20',
                            color: '#ffffff',
                            borderRadius: '6px',
                            outline: 'none',
                            fontSize: "13px"
                        }}
                    />

                    <Button
                        // startIcon={<Add />}
                        style={{
                            width: 'max-content',
                            fontSize: "13px",
                            paddingLeft: "15px", paddingTop: '3px',
                            paddingRight: "15px", paddingBottom: '3px',
                            backgroundColor: "#ffffff15",
                            borderRadius: "100px",
                            border: "1px solid #ffffff25",
                            marginLeft: "10px",
                            textAlign: 'center',
                            fontFamily: 'poppins-reg',
                            textTransform: 'none'
                        }}
                        variant="contained"
                        // component={Link}
                        // to="/admin/addenabledlocation"
                        onClick={HandleResetClick}
                    //   disabled={false}
                    >
                        ⟳ Reset
                    </Button>
                </Box>

            </Box>

            <Box sx={{
                paddingInline: "20px", paddingBlock: "20px",
                alignSelf: 'stretch', flexWrap: 'wrap',
                alignItems: 'center',
                flexDirection: 'row', display: 'flex', gap: "10px",
            }}>

                {
                    postData.map((item, index) => (
                        <Box sx={{
                            flexDirection: 'column', width: isMobileScreen || isTabScreen ? "100%" : "450px", height: "400px", border: "2px solid #aaaaaa10",
                            borderRadius: "20px", background: "#ffffff02", display: 'flex'
                        }}>

                            <Box sx={{
                                flexDirection: 'row', alignItems: 'center', display: 'flex', paddingInline: "15px", paddingBlock: "10px",
                                borderBottom: "1px solid #aaaaaa10"
                            }}>

                                <img src={item.creator.clubLogo || item.creator.image[0]}
                                    style={{ borderRadius: "100px", overflow: 'hidden', border: "2px solid #aaaaaa10", objectFit: 'contain', width: "35px", height: "35px" }} />

                                <Box sx={{ flexDirection: 'column', display: 'flex', marginInline: "10px", flex: 1 }}>

                                    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: "10px", }}>
                                        <Typography style={{
                                            fontFamily: 'poppins-reg', fontSize: "13px", color: "#ffffff",
                                        }}>{item.creator.title ? item.creator.title : item.creator.full_name}</Typography>
                                        <Typography style={{
                                            background: "#aaaaaa10",
                                            borderRadius: "100px",
                                            paddingInline: "8px", paddingBlock: "1px",
                                            fontFamily: 'poppins-reg', fontSize: "10px", color: "#ffffff80",
                                        }}>{item.creator.buzz_name || "club"}</Typography>
                                    </Box>

                                    <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex", gap: "3px" }}>

                                        {
                                            item.space && (
                                                <LinkRounded style={{ fontSize: "15px", color: "#a256ff" }} />
                                            )
                                        }
                                        <Typography style={{
                                            fontFamily: 'poppins-reg', fontSize: "10px", color: "#ffffff80",
                                        }}>{getFormattedTime(item.createdAt)}</Typography>
                                    </Box>




                                </Box>

                                {
                                    item.isFlagged && (
                                        <Box
                                            onClick={() => {
                                                handleClearFlag(item._id)
                                            }}
                                            sx={{
                                                border: "1.5px solid #aaaaaa10", padding: "5px", borderRadius: "4px", alignSelf: 'center',
                                                alignItems: 'center', justifyContent: 'center', display: 'flex', background: "#ffffff06", cursor: 'pointer',
                                                marginRight: "10px"
                                            }}>
                                            <ExplicitRounded style={{ color: "orange" }} />
                                        </Box>
                                    )
                                }



                                <Box
                                    onClick={() => {
                                        handleDelete(item._id)
                                    }}
                                    sx={{
                                        border: "1.5px solid #aaaaaa10", padding: "5px", borderRadius: "4px", alignSelf: 'center',
                                        alignItems: 'center', justifyContent: 'center', display: 'flex', background: "#ffffff06", cursor: 'pointer'
                                    }}>
                                    <DeleteOutlineRounded style={{ color: "#f0f0f090" }} />
                                </Box>


                            </Box>

                            <Typography style={{
                                display: '-webkit-box',
                                WebkitLineClamp: 4, // number of lines
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                fontFamily: 'poppins-reg', fontSize: "12.5px", color: "#f0f0f0", margin: "10px"
                            }}>{item.content}</Typography>

                            {
                                item.media && item.media.length > 0 && (
                                    <Box sx={{
                                        whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', overflowX: 'auto', gap: "10px", paddingInline: "10px",
                                        scrollbarWidth: 'thin', // Firefox
                                        paddingBottom: "10px",
                                        scrollbarColor: '#ffffff20 #000',

                                        // ✅ WebKit (Chrome, Edge, Safari)
                                        '&::-webkit-scrollbar': {
                                            height: '6px',
                                        },
                                        '&::-webkit-scrollbar-button': {
                                            display: 'none',
                                            width: 0,
                                            height: 0,
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            backgroundColor: '#888', // 👈 make it visible first
                                            borderRadius: '8px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            backgroundColor: '#00000020',
                                        },
                                    }} >

                                        {
                                            item.media.map((url, idx) => (
                                                <Box sx={{
                                                    width: item.media.length == 1 ? "220px" : "110px", minWidth: "110px", height: "150px", background: "#ffffff05", borderRadius: "10px", overflow: 'hidden',
                                                    border: "3px solid #ffffff05"
                                                }}>

                                                    <img src={url} style={{ width: "100%", height: "100%", objectFit: 'cover' }} />

                                                </Box>
                                            ))
                                        }



                                    </Box>

                                )
                            }

                            <Box sx={{ flexDirection: 'column', display: 'flex', justifyContent: 'flex-end', flex: 1, }}>

                                <Box sx={{ flexDirection: 'row', alignItems: 'center', display: "flex", padding: "15px", borderTop: "1px solid #aaaaaa10" }}>

                                    <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', paddingRight: "10px", borderRight: "0px solid #ffffff10" }}>
                                        <Typography style={{
                                            fontFamily: 'poppins-reg', fontSize: "12px", color: item.reactionCount > 0 ? "#ffffff" : "#ffffff90", marginLeft: "4px"
                                        }}>{item.reactionCount} Likes</Typography>
                                    </Box>
                                    <Box sx={{ width: "4px", height: "4px", borderRadius: "100px", backgroundColor: "#ffffff50" }} />
                                    <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', paddingInline: "5px", borderRight: "0px solid #ffffff10" }}>
                                        <Typography style={{
                                            fontFamily: 'poppins-reg', fontSize: "12px", color: item.commentsCount > 0 ? "#ffffff" : "#ffffff90", marginLeft: "4px"
                                        }}>{item.commentsCount} Comments</Typography>
                                    </Box>

                                    <Box sx={{ display: "flex", flex: 1 }} />

                                    <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', paddingRight: "10px", borderRight: "0px solid #ffffff10" }}>
                                        <Typography style={{
                                            fontFamily: 'poppins-reg', fontSize: "12px", color: item.impressionCount > 0 ? "#ffffff" : "#ffffff90", marginLeft: "4px"
                                        }}>{item.impressionCount} impressions</Typography>
                                    </Box>
                                    <Box sx={{ width: "4px", height: "4px", borderRadius: "100px", backgroundColor: "#ffffff50" }} />
                                    <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', paddingInline: "5px", borderRight: "0px solid #ffffff10" }}>
                                        <Typography style={{
                                            fontFamily: 'poppins-reg', fontSize: "12px", color: item.shareCount > 0 ? "#ffffff" : "#ffffff90", marginLeft: "4px"
                                        }}>{item.shareCount} Shares</Typography>
                                    </Box>


                                </Box>
                            </Box>




                        </Box>
                    ))
                }





            </Box>
            {
                !hasEnded && (
                    <Typography onClick={() => {
                        getPosts(currentPage + 1, option, selectedDate, contentType == "flagged")
                    }} style={{
                        color: "white", fontFamily: 'poppins-reg', fontSize: "13px", paddingInline: "15px", paddingBlock: "5px",
                        borderRadius: "8px", border: "2px solid #aaaaaa20", background: "#aaaaaa10", alignSelf: 'center', marginBottom: "200px", marginTop: " 70px", cursor: "pointer"
                    }}>
                        Load More
                    </Typography>
                )
            }

        </Box>
    );
};

export default UserContent;
